<template>
    <div class="ui basic segment">
        <div v-if="step_number == 1">
            <form action="#" class="ui form">
                <div class="field">
                    <label for="group_id">Группа</label>
                    <select name="group_id" class="ui fluid search selection dropdown" v-model="group_id"
                            @change="getPeriod">
                        <option value="" disabled>Выберите группу</option>
                        <option v-for="item in groups" :value="item.id">{{ item.label }}</option>
                    </select>
                </div>
                <div class="field" v-show="group_id">
                    <label for="year_id">Учебный год</label>
                    <select name="year_id" class="ui fluid search selection dropdown" v-model="year_id">
                        <option value="" disabled>Выберите учебный год</option>
                        <option v-for="item in years" :value="item.id">{{ item.label }}</option>
                    </select>
                </div>
                <div class="field" v-show="year_id">
                    <label for="period">Период контроля</label>
                    <select name="period" class="ui fluid search selection dropdown" v-model="period"
                            @change="getDisciplines">
                        <option value="" disabled>Выберите семестр</option>
                        <option v-for="item in periods" :value="item.label">{{ item.label }}</option>
                    </select>
                </div>
            </form>
            <div class="ui fluid vertical menu" v-if="undoneDisciplines.length > 0">
                <a class="item " v-for="item in undoneDisciplines" @click="setDiscipline(item)" :style="item.delete_flag ? `background-color: #fb393940` : ''">{{item.discipline_name}} ({{item.load}})</a>
            </div>
        </div>
        <div v-if="step_number == 2">
            <div class="ui header"><i class="link icon left chevron"  @click="getHome()"></i>ЗАЧЕТНО-ЭКЗАМЕНАЦИОННАЯ ВЕДОМОСТЬ №{{ statement.number }} от {{ new Date(statement.document_date).toLocaleDateString() }}</div>
            <form action="#" class="ui form">
                <table class="ui celled compact small table top attached">
                    <tbody>
                    <tr>
                        <td class="three wide"><b>Период контроля</b></td>
                        <td>{{ statement.year }} / {{statement.period}}</td>
                    </tr>
                    <tr>
                        <td><b>Форма контроля</b></td>
                        <td>{{ statement.load }}</td>
                    </tr>
                    <tr>
                        <td><b>Подразделение</b></td>
                        <td>{{ statement.department }}</td>
                    </tr>
                    <tr>
                        <td><b>Направление подготовки (специальность)</b></td>
                        <td>{{ statement.speciality }}</td>
                    </tr>
                    <tr>
                        <td><b>Учебный план</b></td>
                        <td>{{ statement.curriculum }}</td>
                    </tr>
                    <tr>
                        <td><b>Форма обучения</b></td>
                        <td>{{ statement.form }}</td>
                    </tr>
                    <tr>
                        <td><b>Группа</b></td>
                        <td>{{ statement.group }}</td>
                    </tr>
                    <tr>
                        <td><b>Курс</b></td>
                        <td>{{ statement.course_name }}</td>
                    </tr>
                    <tr>
                        <td><b>Дисциплина</b></td>
                        <td>{{ statement.discipline }}</td>
                    </tr>
                    <tr>
                        <td><b>Преподаватель</b></td>
                        <td>
                            <div class="ui bulleted list" v-if="Array.isArray(statement.teachers)">
                                <div class="item" v-for="teacher_row in statement.teachers">{{ teacher_row.teacher }}</div>
                            </div>
                            <div class="" v-else>
                                {{ statement.teachers == undefined ? '' : statement.teachers.teacher }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                      <td><b>Количество часов/недель ЗЕТ</b></td>
                      <td>{{ statement.zet }}</td>
                    </tr>
                    <tr>
                        <td><b>Дата проведения</b></td>
                        <td>
                            <div class="field"><input type="date" v-model="statement.session_date"></div>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Время начала</b></td>
                        <td>
                            <div class="field"><input type="time" v-model="statement.start"></div>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Время заверешения</b></td>
                        <td>
                            <div class="field"><input type="time" v-model="statement.end"></div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="ui celled compact small table  attached">
                    <thead>
                    <tr>
                        <th colspan="3"><b>Студенты</b></th>
                    </tr>
                    <tr>
                        <th>Фамилия, имя, отчество</th>
                        <th>Номер зачетной книжки</th>
                        <th>Оценка</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="student_row in statement.students">
                        <td>{{ student_row.student }}</td>
                        <td>{{ student_row.book }}</td>
                        <td>
                            <div class="field">
                                <select class="ui fluid search selection dropdown" v-model="student_row.score">
                                    <option value="" disabled>Выберите оценку</option>
                                    <option v-for="item in filteredScores" :value="item.id1c">{{ item.name }}</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </form>
            <button class="ui primary fluid button bottom attached" @click="updateStatement">Сохранить</button>
        </div>
        <div v-if="step_number == 3">
            <div :class="`ui ${result === 'error' ? 'negative' : 'info'} icon message large`" >
                <i class="info icon"></i>
                <div class="content">
                    <div class="header">{{ result_message }}</div>
                </div>
            </div>
            <div></div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "statement_edit",
        data: () => ({
            errors: [],
            result_message: '',
            step_number: 1,
            group_id: '',
            groups: [],
            year_id: '',
            years: [],
            period: '',
            periods: [],
            discipline: {},
            disciplines: [],
            statement: {},
            scores: [],
            result: ''
        }),
        computed: {
            filteredScores: function() {
                return this.scores.filter(score => ['Пятибалльная', 'Двубалльная'].includes(score.system_score)).sort((a, b) => a.position > b.position ? 1 : -1).sort((a, b) => a.system_score < b.system_score ? 1 : -1)
            },
            undoneDisciplines: function() {
                return this.disciplines.filter(discipline => discipline.done_flag === false)
            }
        },
        methods: {
            async getGroups() {
                await axios.get(`/reference/groups/autocomplete_group_name`)
                    .then(response => this.groups = response.data.groups)
            },
            async getYears() {
                await axios.get(`/reference/study_years/autocomplete_study_year_name`)
                    .then(response => this.years = response.data.study_years)
            },
            getScores() {
                axios.get(`/study/get_scores`)
                    .then(response => this.scores = response.data.scores)
            },
            getPeriod() {
                this.period = ''
                this.disciplines = []
                axios.get(`/reference/groups/autocomplete_period_name?id=${this.group_id}`)
                    .then(response => this.periods = response.data.periods)
            },
            getDisciplines() {
                axios.get(`/study/undone_statments.json?group_id=${this.group_id}&year_id=${this.year_id}&period=${this.period}`)
                    .then(response => this.disciplines = response.data.disciplines)
            },
            getStatment() {
                axios.get(`/study/undone_statments.json?id1c=${this.discipline.id1c}`)
                    .then(response => this.statement = response.data.statement)

            },
            updateStatement() {
                axios.post('/study/update_university_statement', {statement: this.statement})
                    .then(response => {
                        this.result = response.data.result
                        this.step_number = 3
                        if (this.result === 'saved') {
                            this.result_message = `Зачетно-экзаменационная ведомость №${this.statement.number} от ${new Date(this.statement.document_date).toLocaleDateString()} сохранена и может быть отредактирована вами или другими преподавателями`
                        }
                        if (this.result === 'done') {
                            this.result_message = `Зачетно-экзаменационная ведомость №${this.statement.number} от ${new Date(this.statement.document_date).toLocaleDateString()} сохранена и проведена. Редактировать данные может только сотрудник деканата`
                        }
                        this.statement = {}
                    })
                    .catch(error => {
                        this.result = 'error'
                        this.step_number = 3
                        this.errors = error.response
                        this.result_message = `Зачетно-экзаменационная ведомость №${this.statement.number} от ${new Date(this.statement.document_date).toLocaleDateString()} не сохранилась из-за ошибок в данных ведомости в программе 1С Университет ПРОФ. Свяжитесь с Деканатом.`
                        this.statement = {}
                    })
            },
            setDiscipline(discipline) {
                this.discipline = discipline
                this.step_number = 2
                this.reloadScripts()
                this.getScores()
                this.getStatment()
            },
            getHome() {
                this.step_number = 1
                this.reloadScripts()
            },
            reloadScripts() {
                $('.popup-item').popup();
                $('.ui.dropdown').dropdown({});
                $('.ui.checkbox').checkbox();
            }
        },
        mounted() {
            this.getGroups()
            this.getYears()
        },
        watch: {

        },

    }
</script>

<style scoped>

</style>